export default function CurrentHoldings({ holdings, lastUpdated, loading }) {
  const getValueClass = (value) => (value.startsWith("-") ? "negative" : "positive");
  const rows = Array.isArray(holdings) ? holdings : [];

  return (
    <div className="card table-card">
      <div className="card-header">
        <span className="card-title">Current Holdings</span>
      </div>
      <table className="data-table">
        <thead>
          <tr>
            <th>Crypto</th>
            <th>Portfolio %</th>
            <th>Expected APY</th>
            <th>Latest Funding Rate</th>
            <th>Previous Funding Rate</th>
            <th>3D Cum APR</th>
            <th>7D Cum APR</th>
            <th>30D Cum APR</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            [1, 2, 3].map((i) => (
              <tr key={`loading-${i}`}>
                <td>
                  <div className="crypto-cell">
                    <span className="table-cell-placeholder" style={{ width: 36, height: 36, borderRadius: '50%' }} aria-hidden="true" />
                    <div>
                      <span className="table-cell-placeholder" style={{ width: 60, display: 'inline-block' }} aria-hidden="true" />
                      <br />
                      <span className="table-cell-placeholder" style={{ width: 80, display: 'inline-block', marginTop: 4 }} aria-hidden="true" />
                    </div>
                  </div>
                </td>
                <td><span className="table-cell-placeholder" style={{ width: 56 }} aria-hidden="true" /></td>
                <td><span className="table-cell-placeholder" style={{ width: 64 }} aria-hidden="true" /></td>
                <td><span className="table-cell-placeholder" style={{ width: 64 }} aria-hidden="true" /></td>
                <td><span className="table-cell-placeholder" style={{ width: 64 }} aria-hidden="true" /></td>
                <td><span className="table-cell-placeholder" style={{ width: 56 }} aria-hidden="true" /></td>
                <td><span className="table-cell-placeholder" style={{ width: 56 }} aria-hidden="true" /></td>
                <td><span className="table-cell-placeholder" style={{ width: 56 }} aria-hidden="true" /></td>
              </tr>
            ))
          ) : rows.length === 0 ? (
            <tr>
              <td colSpan="8">No data available.</td>
            </tr>
          ) : (
            rows.map((asset) => (
              <tr key={asset.name}>
                <td>
                  <div className="crypto-cell">
                    <div className="crypto-icon" style={{ background: asset.color }}>
                      {asset.symbol}
                    </div>
                    <div>
                      <div className="crypto-name">{asset.name}</div>
                      <div className="crypto-pair">{asset.pair}</div>
                    </div>
                  </div>
                </td>
                <td>{asset.portfolio}</td>
                <td className="positive">{asset.expectedApy}</td>
                <td className="positive">{asset.latestFunding}</td>
                <td className="positive">{asset.previousFunding}</td>
                <td className={getValueClass(asset.cum3d)}>{asset.cum3d}</td>
                <td className={getValueClass(asset.cum7d)}>{asset.cum7d}</td>
                <td className={getValueClass(asset.cum30d)}>{asset.cum30d}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      <div className="last-updated">
        Last updated: {lastUpdated || "—"}
      </div>
    </div>
  );
}
